document.querySelectorAll('.AccompanyTransactionAS form').forEach((form) => {
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        openModal('.AccompanyTransactionASModal');
        form.reset();
        document.activeElement.blur();
    })
})
